export default "__VITE_PUBLIC_ASSET__7c90df81__"